/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'confluence.error.panel.refresh.app': "Actualiser l'app",
  'confluence.error.panel.reload.page': 'Recharger la page',
  'confluence.icon.label': 'Icône',
  'confluence.modal.dialog.close.modal.button': 'Annuler',
  'confluence.select.required.field.message': 'Ce champ est obligatoire.',
  'confluence.text.area.required.field.message': 'Ce champ est obligatoire.',
  'confluence.textfield.validator.email': 'Saisissez une adresse e-mail valide.',
  'confluence.textfield.validator.number': 'Indiquez un nombre valide',
  'confluence.textfield.validator.required.field.message': 'Ce champ est obligatoire.',
  'confluence.textfield.validator.telephone': 'Saisissez un numéro de téléphone valide.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Accès requis',
  'confluence.threeLOPrompt.modal.error.title': 'Erreur',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'URL de consentement introuvable. Veuillez actualiser la page et réessayer.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'URL de consentement introuvable. Veuillez actualiser la page et réessayer.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': "Autoriser l'accès",
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': "Configurer l'accès",
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': "Échec de l'authentification.",
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    "Pour afficher {appString}, vous devez autoriser l'app à accéder aux produits Atlassian en votre nom.",
  'confluence.threeLOPrompt.use-auth.default.prompt.message-appify':
    "Pour afficher {appString}, vous devez l'autoriser à accéder aux apps Atlassian en votre nom.",
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} nécessite un accès supplémentaire à votre compte.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': "Avertissement d'authentification externe",
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'cette app',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Cette app',
  'confluence.user.group.unknown.user.message': 'Utilisateur inconnu',
  'confluence.user.picker.empty.field.error.message': 'Ce champ est obligatoire.',
  'confluence.user.unknown.user.message': 'Utilisateur inconnu',
  'forge-ui.form.submit-button.text': 'Envoyer',
  'forge.modal.deprecation.message':
    "Votre app {appName} utilise l'expérience d'édition modale obsolète pour les champs personnalisés, qui est en cours de suppression. Veuillez demander à votre administrateur système de mettre à jour l'application pour pouvoir utiliser la modification en ligne. Si le problème persiste, contactez le développeur de l'application.",
  'forge.modal.deprecation.title': 'Mettez à jour votre app',
};
